import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { X, Search, ArrowRight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const POPULAR = ["Dresses", "Sarees", "Blazers", "Kurtis", "Jeans", "Ethnic Wear"];

export function SearchOverlay({ open, onClose }) {
  const [query, setQuery] = useState("");
  const inputRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (open) {
      setTimeout(() => inputRef.current?.focus(), 100);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  const handleSearch = (q) => {
    const term = (q || query).trim();
    if (!term) return;
    navigate(`/search?q=${encodeURIComponent(term)}`);
    setQuery("");
    onClose();
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 bg-white z-[60] flex flex-col"
        >
          <div className="max-w-fashion-content mx-auto w-full px-4 md:px-8 pt-6">
            {/* Close */}
            <div className="flex justify-end mb-8">
              <button onClick={onClose} className="p-2 text-fashion-text-muted hover:text-fashion-text">
                <X className="h-5 w-5" strokeWidth={1.5} />
              </button>
            </div>

            {/* Search Input */}
            <div className="border-b-2 border-fashion-text pb-2 flex items-center gap-3">
              <Search className="h-5 w-5 text-fashion-text-muted flex-shrink-0" strokeWidth={1.5} />
              <input
                ref={inputRef}
                type="text"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                placeholder="Search for clothing, brands, styles…"
                className="w-full bg-transparent text-xl md:text-2xl font-display font-light text-fashion-text outline-none placeholder:text-fashion-text-light"
              />
              {query && (
                <button onClick={() => handleSearch()} className="p-1 text-fashion-text">
                  <ArrowRight className="h-5 w-5" strokeWidth={1.5} />
                </button>
              )}
            </div>

            {/* Popular Searches */}
            <div className="mt-10">
              <p className="text-overline mb-4">Popular Searches</p>
              <div className="flex flex-wrap gap-2">
                {POPULAR.map((term) => (
                  <button
                    key={term}
                    onClick={() => handleSearch(term)}
                    className="px-4 py-2 border border-fashion-border text-sm text-fashion-text-muted hover:border-fashion-text hover:text-fashion-text transition-colors duration-300"
                  >
                    {term}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
